import React from 'react';
const styles = require('./toast.scss');

interface IProps {
  message: string;
  type: 'success' | 'error' | 'info';
  index: number;
}

interface IState {
  showToast: boolean;
}

let closeToastFn;

export class ToastComponent extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      showToast: true
    }
  }
  componentDidMount(): void {
    closeToastFn = this.closeToast;
  }

  closeToast = () => {
    this.setState({ showToast: false });
  }

  render() {
    return (
      <>
        {this.state.showToast ? <div className={[styles.toast, styles[this.props.type]].join(' ')}>
          {this.props.message}
        </div> : null}
      </>
    )
  }
}

export function closeToast() {
  closeToastFn();
};
export default ToastComponent



// WEBPACK FOOTER //
// ./src/components/toast/toast.component.tsx